import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { observable } from 'mobx';
import { ProductRepository } from '../repositories/ProductRepository';
import { IPowerReviews, IPowerReviewsProduct, IProduct } from '../interfaces/IRating';
import { query, serviceQueries } from 'elc-service-bus';

declare let POWERREVIEWS: IPowerReviews;

export class PowerReviewsInitializedUseCase {
    @observable public productRepository: ProductRepository;
    @observable public productId: string;

    constructor(productId: string) {
        this.productId = productId;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    private renderReviews(powerReviewsProduct: IPowerReviewsProduct) {
        POWERREVIEWS.display.render(powerReviewsProduct);
        const reviewSection = document.querySelector('.spp-reviews-wrapper');
        if (reviewSection) {
            reviewSection.classList.remove('hidden');
        }
    }

    public execute = async () => {
        // tslint:disable-next-line: await-promise
        const products = await query(serviceQueries.GET_REVIEW_PRODUCT, this.productId);

        const powerReviewsProduct: IPowerReviewsProduct = this.productRepository.getPowerReviewsProduct(
            <IProduct[]>products
        );

        const reviewContent = <HTMLElement>document.querySelector('.js-spp-reviews');
        if (reviewContent) {
            reviewContent.id = powerReviewsProduct.reviewDisplayId;
        }

        this.renderReviews(powerReviewsProduct);
    };
}
